var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mask"},[(_vm.texto)?_c('p',[_vm._v(_vm._s(_vm.texto))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"spinner"},[_c('breeding-rhombus-spinner',{attrs:{"animation-duration":2000,"size":95,"color":"#bc1e21"}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26dcfa40","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/includes/Loading.vue
// module id = null
// module chunks = 